module.exports = __webpack_public_path__ + "img/cost_icon_certified.c5130c38.svg";